import { createContext, FC, ReactNode, useContext, useMemo } from 'react';
import { Global } from '@utils/common';

// Define types for the context
export interface ConfigurationsContextType {
  global: typeof Global
}

// Default configuration
const DEFAULT_CONFIG = {
  global: Global
};

// Create the context with default undefined value.
export const ConfigurationsContext = createContext<ConfigurationsContextType | undefined>(undefined);

// Custom hook to use the configurations context
export const useConfigurationsContext= (): ConfigurationsContextType => {
  const context = useContext(ConfigurationsContext);

  //  will throw an error if used outside the provider, since context is initialized as undefined
  // This is a common pattern to ensure that the hook is used within the provider.
  if (!context) {
    throw new Error('useConfigurationsContext must be used within a ConfigurationsProvider');
  }

  return context;
};

interface ConfigurationsProviderProps {
  children: ReactNode;
}

/**
 * ConfigurationsProvider component
 *
 * This Provider should never contain a reference to User and is purely for config options.
 */
export const ConfigurationsProvider: FC<ConfigurationsProviderProps> = ({ children }) => {
  const value = useMemo(() => ({
    ...DEFAULT_CONFIG,
  }), []);

  return (
    <ConfigurationsContext.Provider
      value={value}
    >
      {children}
    </ConfigurationsContext.Provider>
  );
};
